export default __webpack_public_path__ + "static/notebook-1-a9899f9943d6c1ed7e2def3b06fdad53.jpeg";